import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { AbstractControl, FormBuilder, NgControl } from '@angular/forms';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { AppConfig } from '../../../models/config/app-config';
import {VisumErfassungSubFormComponent} from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';
import {Subscription} from 'rxjs';
import {FormSubGroupControl} from '../../../models/formControls/FormSubGroupControl';

@Component({
  selector: 'app-lebensunterhalt-aufenthaltsdetails',
  templateUrl: './lebensunterhalt-aufenthaltsdetails.component.html',
  styleUrls: ['./lebensunterhalt-aufenthaltsdetails.component.scss']
})
export class LebensunterhaltAufenthaltsdetailsComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {

  isAbweichenderVerpflichtungsgeberVisible = undefined;
  private formSub: Subscription;


  constructor(fb: FormBuilder,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl,
              @Inject(APP_CONFIG) public appConfig: AppConfig) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      lebensunterhalt: new FormSubGroupControl(),
      abweichenderVerpflichtungsgeber: new FormSubGroupControl(),
      fruehereAufenthalte: new FormSubGroupControl(),
      erklaerung: new FormSubGroupControl()
    }));
  }

  ngOnInit() {
    super.ngOnInit();

    this.formSub = this.form.valueChanges.subscribe(value => {
      let _isAbweichenderVerpflichtungsgeberVisible = value.lebensunterhalt && value.lebensunterhalt.abweichenderVerpflichtungsgeber === 'jaAbweichend';
      if(this.isAbweichenderVerpflichtungsgeberVisible !== _isAbweichenderVerpflichtungsgeberVisible){
        this.isAbweichenderVerpflichtungsgeberVisible = _isAbweichenderVerpflichtungsgeberVisible;
        this.enableDisableControls();
      }
    });
  }

  ngOnDestroy(): void {
    this.formSub.unsubscribe();
  }

  private enableDisableControls() {
    // FIXME Ohne setTimeout() haben enable() und disable() (manchmal!) keine Auswirkung
    // Fix für Bug VIDEX-2052, MEK-3732 VIDEX-2051 und MEK-3735
    const abweichenderVerpflichtungsgeber: AbstractControl = this.form.controls.abweichenderVerpflichtungsgeber;
    this.enableOrDisableControlWithTimeout(this.isAbweichenderVerpflichtungsgeberVisible, abweichenderVerpflichtungsgeber);
  }

}
